import React from 'react';
import PropTypes from 'prop-types';

import '../../css/sceneSelection.css';

import { generatePreview } from '../../services/renderingClient';

const urls = [
    'https://scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/scenes/f7c98062-9b5c-4d1f-a4c0-80928a6bc480/compositions/index',
    'https://dev.scenes.documents.cimpress.io/v2/fulfillers/test-fulfiller1/scenes/5605b5f7-bd5b-4358-ae76-72277197faf2/compositions/fd2cb49c-5fd1-4b42-8732-a3562bced99d/index',
    'https://scenes.documents.cimpress.io/v2/fulfillers/test-fulfiller1/scenes/f532abf2-7438-499c-802c-74c7ba9dca7b/compositions/index',
    'https://dev.scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/scenes/26386907-c7c9-424e-b74c-0016a390ce06/compositions/index',
    'https://scenes.documents.cimpress.io/v2/merchants/VBU-ImagingAndProduction/scenes/938523ec-18ea-4b06-9564-9c2db1e973f9/compositions/index',
    'https://scenes.documents.cimpress.io/v2/merchants/SceneTestGroup/scenes/6ec3f428-3488-49e3-98cf-224dccb77161/compositions/index',
];

const sceneButton = (onSelectScene, url, scene) => (
    <button key={url} className={`scene-control__scene${scene === url ? ' active' : ''}`} onClick={() => onSelectScene(url)}>
        <img src={generatePreview({ url, height: 100 })} alt='scene' />
    </button>
);

const sceneSelection = ({ onSelectScene, scene, color }) => (
    <div className='color-attribute scene-control' style={{ borderColor: color }}>
        <div className='scene-control__title'>Choose a scene</div>
        <li className='scene-control__scenes'>
            <button className={`scene-control__scene scene-control__scene--none${scene === '' ? ' active' : ''}`} onClick={() => onSelectScene('')}>No Scene</button>
            {urls.map(url => sceneButton(onSelectScene, url, scene))}
        </li>
    </div>
);

sceneSelection.propTypes = {
    onSelectScene: PropTypes.func.isRequired,
    scene: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

export default sceneSelection;



// WEBPACK FOOTER //
// ./src/components/rendering/sceneSelection.jsx